import {
  simpleDeepClone,
  findAllRects,
  getAttrById,
  handleFindLayoutComponentOptions,
  isExist,
  isEqual,
  changeOption
} from "utils"
import { CATEGORY_MODE } from "@/consts"
const IGNORE_PROPERTIES = [
  "activeCol",
  "resizable",
  "draggable",
  "tabsList",
  "errorCode",
  "menuName",
  "menuIconClass",
  "engineInstanceId",
  "engineInstanceAppId",
  "pluginName",
  "emptyData",
  "boundWidth",
  "boundHeight",
  "enableTeleport",
  "appId",
  "publicId",
  "selectOptions",
  "detailOriginUrl",
  "isDrawerModeL",
  "reload",
  "requestUrl",
  "gridLayout",
  "restDataUrl",
  "isEmptyData",
  "currentFiledMapping",
  "detailFieldMapping",
  "colsWidthList",
  "isShowSerialNumber",
  "listData",
  "chartOption.series.0",
  "name"
]
const DEFAULT_PROPERTY_VALUE = {
  contentHasLimit: false,
  textLimitWords: 2,
  showBorder: false,
  syncHeaderNav: true,
  openDialog: false,
  isRefresh: false,
  zoomImage: false,
  showBigButton: false,
  showBigPagination: false,
  showZoomButton: false,
  "globalBgSetting.opacity": 100,
  isShowAnchor: false,
  showCropping: false,
  globalStyle: "",
  mergeMarginPadding: true,
  isShowChangeSchool: false
}

export function addHistory(data) {
  try {
    const payload = simpleDeepClone(data)
    const { type } = payload
    if (type === "add") {
      // 新增时，记录状态不准确，这里不处理，放在undo解决
    }
    if (type === "delete") {
      recordDelete.call(this, payload)
    }
    if (type === "update") {
      // 修改属性时，可能一次触发多次更新，需要排除没必要的记录。增加ignoreFlag标识
      const ignoreFlag = recordUpdate.call(this, payload)
      if (ignoreFlag) {
        return
      }
    }
    deepFreeze(payload)
    this.$store.commit("states/addHistoryState", payload)
  } catch (e) {
    console.log(e)
  }
}

export function undo() {
  const { historyIndex, historyState } = this.$store.state.states
  const state = historyState[historyIndex]
  const { type, stateType, payload } = state
  const { option_name, option_val, deleteCell, index, changingTitleElement, ...ids } = payload
  if (type === "add") {
    undoAdd.call(this, { ...state }, historyIndex)
  }
  if (type === "delete") {
    undoDelete.call(this, state)
  }
  if (type === "update") {
    undoUpdate.call(this, { ...state }, historyIndex)
  }
  this.$store.commit("states/goBackHistory")
  consoleLog("undo", state)
  undoActive.call(this, type, stateType, ids)
}

export function redo() {
  this.$store.commit("states/goNextHistory")
  const { historyIndex, historyState } = this.$store.state.states
  const state = historyState[historyIndex]
  const { type, stateType, payload } = state
  const { option_name, option_val, deleteCell, index, changingTitleElement, ...ids } = payload
  if (type === "add") {
    redoAdd.call(this, state)
  }
  if (type === "delete") {
    redoDelete.call(this, state)
  }
  if (type === "update") {
    redoUpdate.call(this, state)
  }
  consoleLog("redo", state)
  redoActive.call(this, type, stateType, ids)
}

function recordDelete(state) {
  const { stateType, payload } = state
  const {
    pageLayoutId,
    elementInLayoutId,
    uid,
    rect_id,
    directionIndex,
    swiperContent_id,
    elementInSwiperId,
    elementInAutoLayoutId,
    cellVal
  } = payload
  const stage = this.$store.state[this.request_prefix]
  const pageLayoutList = stage.page.pageLayoutList
  const childrens = getAttrById(stage, payload, "container").children
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  // 删除通栏
  if (stateType === "deletePageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    state.payload.index = index
    state.data = deepCloneAndFreeze(pageLayoutList[index])
    state.children = []
    const rects = findAllRects(pageLayoutList[index])
    if (rects.length > 0) {
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rects.includes(childrens[i].rect_id)) {
          state.children.unshift(deepCloneAndFreeze(childrens[i]))
        }
      }
    }
  }
  // 删除标签通栏的列
  if (stateType === "deletePageLayoutCol") {
    if (isExist(rect_id)) {
      const index = childrens.findIndex(layout => layout.rect_id === rect_id)
      state.data = deepCloneAndFreeze(childrens[index])
    }
    state.children = []
    const rectIds = []
    getAllRectsInCell(cellVal, rectIds)
    if (rectIds.length > 0) {
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rectIds.includes(childrens[i].rect_id)) {
          state.children.unshift(deepCloneAndFreeze(childrens[i]))
        }
      }
    }
  }
  // 删除布局里组件
  if (
    stateType === "deleteElement" &&
    isExist(rect_id) &&
    !isExist(elementInLayoutId) &&
    !isExist(uid) &&
    !isExist(elementInSwiperId) &&
    !isExist(elementInAutoLayoutId)
  ) {
    const index = childrens.findIndex(layout => layout.rect_id === rect_id)
    state.data = deepCloneAndFreeze(childrens[index])
    if (!isBigScreen) {
      const path = findPath(
        pageLayoutList,
        "rectIds",
        rect_id,
        `this.$store.state.${this.request_prefix}.page.pageLayoutList`,
        "include"
      )
      state.mapping = path
    }
  }
  // 删除自由布局里组件
  if (stateType === "deleteElement" && isExist(uid) && isExist(elementInLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
    const elementOptions = handleFindLayoutComponentOptions([rect.options.rows[useActiveIndex]], uid)
    const index = elementOptions.findIndex(element => element.elementInLayoutId === elementInLayoutId)
    state.data = deepCloneAndFreeze(elementOptions[index])
  }
  // 删除自由布局周围组件
  if (stateType === "deleteElement" && isExist(directionIndex)) {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options.titleOptions[directionIndex].elementOptions
    const index = elementOptions.findIndex(element => element.elementInLayoutId === elementInLayoutId)
    state.data = deepCloneAndFreeze(elementOptions[index])
  }
  // 删除轮播里组件
  if (stateType === "deleteElement" && isExist(swiperContent_id) && isExist(elementInSwiperId)) {
    const rect = getAttrById(stage, payload, "swiperContent")
    const elementOptions = rect.elementOptions
    const index = elementOptions.findIndex(item => item.elementInSwiperId === elementInSwiperId)
    state.data = deepCloneAndFreeze(elementOptions[index])
  }
  // 删除自动布局里的组件
  if (stateType === "deleteElement" && isExist(elementInAutoLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options ? rect.options.elementOptions : rect.elementOptions
    const index = elementOptions.findIndex(item => item.elementInAutoLayoutId === elementInAutoLayoutId)
    state.data = deepCloneAndFreeze(elementOptions[index])
    state.payload.index = index
  }
}

function recordUpdate(state) {
  const { stateType, payload, ignoreRecord, before, data } = state
  const { deleteCell, option_name, option_val } = payload
  const { historyIndex, historyState } = this.$store.state.states
  const stage = this.$store.state[this.request_prefix]
  const childrens = getAttrById(stage, payload, "container").children
  const page = stage.page
  // 修改布局
  if (stateType === "updatePageLayout" && deleteCell) {
    const rectIds = []
    getAllRectsInCell(deleteCell, rectIds)
    delete payload.deleteCell
    state.children = []
    if (rectIds.length > 0) {
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rectIds.includes(childrens[i].rect_id)) {
          state.children.unshift(deepCloneAndFreeze(childrens[i]))
        }
      }
    }
  }
  // 修改属性值
  if (stateType === "updateProperty") {
    if (IGNORE_PROPERTIES.includes(option_name)) {
      return true
    } else {
      const historyValueChangeing = sessionStorage.getItem("historyValueChangeing")
      const historyValueCombine = sessionStorage.getItem("historyValueCombine")
      const attr = getAttribute.call(this, payload)
      if (!attr) {
        return true
      }
      const oldValue = ignoreRecord ? before : getOptionValue(attr, option_name)
      const newValue = ignoreRecord ? data : option_val
      if (isEqual(oldValue, newValue)) {
        return true
      }
      if (!historyValueChangeing && !historyValueCombine) {
        state.before = deepCloneAndFreeze(oldValue)
        state.data = deepCloneAndFreeze(newValue)
      } else if (historyValueChangeing) {
        // 这里是持续更改的值，记录历史时，在之前的值上面更新
        const oldState = simpleDeepClone(historyState[historyIndex])
        if (Array.isArray(oldState.payload.option_name)) {
          if (Array.isArray(option_name)) {
            option_name.forEach(name => {
              const index = oldState.payload.option_name.indexOf(name)
              oldState.data[index] = deepCloneAndFreeze(newValue)
            })
          } else {
            const index = oldState.payload.option_name.indexOf(option_name)
            oldState.data[index] = deepCloneAndFreeze(newValue)
          }
        } else {
          oldState.data = deepCloneAndFreeze(newValue)
        }
        this.$store.commit("states/updateHistory", { index: historyIndex, state: oldState })
        return true
      } else if (historyValueCombine) {
        // 多次修改合并，第一次取当前state，后续取前面一个state
        const curState = historyValueCombine === "1" ? state : simpleDeepClone(historyState[historyIndex])
        // 这里是指修改一个值，涉及修改另外多个值的情况，直接在之前的基础上修改
        if (historyValueCombine === "1") {
          curState.before = []
          curState.data = []
          curState.payload.option_name = []
          curState.payload.option_val = []
          combineValues()
          sessionStorage.setItem("historyValueCombine", parseInt(historyValueCombine) + 1)
        } else {
          combineValues()
          this.$store.commit("states/updateHistory", { index: historyIndex, state: curState })
          sessionStorage.setItem("historyValueCombine", parseInt(historyValueCombine) + 1)
          return true
        }
        function combineValues() {
          if (Array.isArray(option_name)) {
            option_name.forEach((name, index) => {
              updater(name, newValue[index], oldValue[index])
            })
          } else {
            updater(option_name, newValue, oldValue)
          }
        }
        function updater(name, newVal, oldVal) {
          const idx = curState.payload.option_name.indexOf(name)
          if (idx > -1) {
            curState.data[idx] = deepCloneAndFreeze(newVal)
            curState.payload.option_val[idx] = deepCloneAndFreeze(newVal)
          } else {
            curState.before.push(deepCloneAndFreeze(oldVal))
            curState.data.push(deepCloneAndFreeze(newVal))
            curState.payload.option_name.push(name)
            curState.payload.option_val.push(deepCloneAndFreeze(newVal))
          }
        }
      }
    }
  }
  // 修改页面属性值
  if (stateType === "updatePageProperty") {
    const historyValueChangeing = sessionStorage.getItem("historyValueChangeing")
    const oldValue = ignoreRecord ? before : getOptionValue(page, option_name)
    const newValue = ignoreRecord ? data : option_val
    if (isEqual(oldValue, newValue)) {
      return true
    }
    if (!historyValueChangeing) {
      state.before = deepCloneAndFreeze(oldValue)
      state.data = deepCloneAndFreeze(newValue)
    } else {
      // 这里是持续更改的值，记录历史时，在之前的值上面更新
      const oldState = simpleDeepClone(historyState[historyIndex])
      oldState.data = deepCloneAndFreeze(newValue)
      this.$store.commit("states/updateHistory", { index: historyIndex, state: oldState })
      return true
    }
  }
}

function undoAdd(state, historyIndex) {
  const { stateType, payload } = state
  const { pageLayoutId, rect_id, elementInLayoutId, direction, elementInAutoLayoutId } = payload
  const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
  const stage = this.$store.state[this.request_prefix]
  const childrens = getAttrById(stage, payload, "container").children
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  // 增加新的通栏
  if (stateType === "addPageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    state.payload = { ...payload, index }
    // 在撤销时，才备份布局和内部组件
    if (!state.data) {
      state.data = deepCloneAndFreeze(pageLayoutList[index])
      state.children = []
      const rects = findAllRects(pageLayoutList[index])
      if (rects.length > 0) {
        for (let i = childrens.length - 1; i >= 0; i--) {
          if (rects.includes(childrens[i].rect_id)) {
            state.children.unshift(deepCloneAndFreeze(childrens[i]))
            childrens.splice(i, 1)
          }
        }
      }
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    } else {
      const rects = findAllRects(pageLayoutList[index])
      if (rects.length > 0) {
        for (let i = childrens.length - 1; i >= 0; i--) {
          if (rects.includes(childrens[i].rect_id)) {
            childrens.splice(i, 1)
          }
        }
      }
    }
    pageLayoutList.splice(index, 1)
  }
  // 增加新的组件到布局
  if (stateType === "addRect") {
    const index = childrens.findIndex(layout => layout.rect_id === rect_id)
    if (!state.data) {
      state.data = deepCloneAndFreeze(childrens[index])
      if (!isBigScreen) {
        const pageIndex = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
        const path = findPath(
          pageLayoutList[pageIndex],
          "rectIds",
          rect_id,
          `this.$store.state.${this.request_prefix}.page.pageLayoutList[${pageIndex}].`,
          "include"
        )
        state.mapping = path
      }
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    }
    if (!isBigScreen) {
      const rects = eval(`${state.mapping}`)
      const rectIndex = rects.indexOf(rect_id)
      rects.splice(rectIndex, 1)
    }
    childrens.splice(index, 1)
  }
  // 增加新的组件到自由布局
  if (stateType === "addCellElement") {
    const rect = getAttrById(stage, payload, "rect")
    const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
    const elementOptions = handleFindLayoutComponentOptions([rect.options.rows[useActiveIndex]], payload.uid)
    const index = elementOptions.findIndex(element => element.elementInLayoutId === elementInLayoutId)
    if (!state.data) {
      state.data = deepCloneAndFreeze(elementOptions[index])
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    }
    elementOptions.splice(index, 1)
  }
  // 增加新的组件到自由布局侧边栏
  if (stateType === "addLayoutAroundElement") {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options.titleOptions[direction].elementOptions
    const index = elementOptions.findIndex(element => element.elementInLayoutId === elementInLayoutId)
    if (!state.data) {
      state.data = deepCloneAndFreeze(elementOptions[index])
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    }
    elementOptions.splice(index, 1)
  }
  // 增加新的组件到自动布局
  if (stateType === "addAutoLayoutElement") {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options.elementOptions
    const index = elementOptions.findIndex(element => element.elementInAutoLayoutId === elementInAutoLayoutId)
    if (!state.data) {
      state.data = deepCloneAndFreeze(elementOptions[index])
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    }
    elementOptions.splice(index, 1)
  }
}

function redoAdd(state) {
  const { stateType, payload, data, children, mapping } = state
  const { index, rect_id, uid, direction } = payload
  const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
  const stage = this.$store.state[this.request_prefix]
  const childrens = getAttrById(stage, payload, "container").children
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  // 增加新的通栏
  if (stateType === "addPageLayout") {
    if (children.length > 0) {
      children.forEach(child => {
        childrens.push(simpleDeepClone(child))
      })
    }
    pageLayoutList.splice(index, 0, simpleDeepClone(data))
  }
  // 增加新的组件到布局
  if (stateType === "addRect") {
    childrens.push(simpleDeepClone(data))
    if (!isBigScreen) {
      const rects = eval(`${mapping}`)
      rects.push(rect_id)
    }
  }
  // 增加新的组件到自由布局
  if (stateType === "addCellElement") {
    const rect = getAttrById(stage, payload, "rect")
    const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
    const elementOptions = handleFindLayoutComponentOptions([rect.options.rows[useActiveIndex]], uid)
    elementOptions.push(simpleDeepClone(data))
  }
  // 增加新的组件到自由布局侧边栏
  if (stateType === "addLayoutAroundElement") {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options.titleOptions[direction].elementOptions
    elementOptions.push(simpleDeepClone(data))
  }
  // 增加新的组件到自动布局
  if (stateType === "addAutoLayoutElement") {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options.elementOptions
    elementOptions.splice(index, 0, simpleDeepClone(data))
  }
}

function undoDelete(state) {
  const { stateType, payload, data, children, mapping, before } = state
  const {
    index,
    rect_id,
    elementInLayoutId,
    uid,
    directionIndex,
    swiperContent_id,
    elementInSwiperId,
    elementInAutoLayoutId
  } = payload
  const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
  const stage = this.$store.state[this.request_prefix]
  const childrens = getAttrById(stage, payload, "container").children
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  // 删除通栏
  if (stateType === "deletePageLayout") {
    if (children.length > 0) {
      children.forEach(child => {
        childrens.push(simpleDeepClone(child))
      })
    }
    pageLayoutList.splice(index, 0, simpleDeepClone(data))
  }
  // 删除标签通栏的列
  if (stateType === "deletePageLayoutCol") {
    if (children.length > 0) {
      children.forEach(child => {
        childrens.push(simpleDeepClone(child))
      })
    }
    const index = childrens.findIndex(layout => layout.rect_id === rect_id)
    childrens.splice(index, 1, simpleDeepClone(before))
  }
  // 删除布局里组件
  if (
    stateType === "deleteElement" &&
    isExist(rect_id) &&
    !isExist(elementInLayoutId) &&
    !isExist(uid) &&
    !isExist(elementInSwiperId) &&
    !isExist(elementInAutoLayoutId)
  ) {
    childrens.push(simpleDeepClone(data))
    if (!isBigScreen) {
      const rects = eval(`${mapping}`)
      rects.push(rect_id)
    }
  }
  // 删除自由布局里组件
  if (stateType === "deleteElement" && isExist(uid) && isExist(elementInLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const useActiveIndex = rect.options.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.options.activeIndex
    const elementOptions = handleFindLayoutComponentOptions([rect.options.rows[useActiveIndex]], uid)
    elementOptions.push(simpleDeepClone(data))
  }
  // 删除自由布局周围组件
  if (stateType === "deleteElement" && isExist(directionIndex)) {
    const param = {
      ...payload,
      value: true
    }
    this.$store.commit(`${this.request_prefix}/CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE`, param)
  }
  // 删除轮播里组件
  if (stateType === "deleteElement" && isExist(swiperContent_id) && isExist(elementInSwiperId)) {
    const rect = getAttrById(stage, payload, "swiperContent")
    const elementOptions = rect.elementOptions
    elementOptions.push(simpleDeepClone(data))
  }
  // 删除自动布局里的组件
  if (stateType === "deleteElement" && isExist(elementInAutoLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options ? rect.options.elementOptions : rect.elementOptions
    elementOptions.splice(index, 0, simpleDeepClone(data))
  }
}

function redoDelete(state) {
  const { stateType, payload, mapping, data } = state
  const {
    index,
    rect_id,
    elementInLayoutId,
    uid,
    directionIndex,
    swiperContent_id,
    elementInSwiperId,
    cellVal,
    elementInAutoLayoutId
  } = payload
  const pageLayoutList = this.$store.state[this.request_prefix].page.pageLayoutList
  const stage = this.$store.state[this.request_prefix]
  const childrens = getAttrById(stage, payload, "container").children
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  // 删除通栏
  if (stateType === "deletePageLayout") {
    const rects = findAllRects(pageLayoutList[index])
    if (rects.length > 0) {
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rects.includes(childrens[i].rect_id)) {
          childrens.splice(i, 1)
        }
      }
    }
    pageLayoutList.splice(index, 1)
  }
  // 删除标签通栏的列
  if (stateType === "deletePageLayoutCol") {
    const rectIds = []
    getAllRectsInCell(cellVal, rectIds)
    if (rectIds.length > 0) {
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rectIds.includes(childrens[i].rect_id)) {
          childrens.splice(i, 1)
        }
      }
    }
    const index = childrens.findIndex(layout => layout.rect_id === rect_id)
    childrens.splice(index, 1, simpleDeepClone(data))
  }
  // 删除布局里组件
  if (
    stateType === "deleteElement" &&
    isExist(rect_id) &&
    !isExist(elementInLayoutId) &&
    !isExist(uid) &&
    !isExist(elementInSwiperId) &&
    !isExist(elementInAutoLayoutId)
  ) {
    const index = childrens.findIndex(layout => layout.rect_id === rect_id)
    childrens.splice(index, 1)
    if (!isBigScreen) {
      const rects = eval(`${mapping}`)
      const rectIndex = rects.indexOf(rect_id)
      rects.splice(rectIndex, 1)
    }
  }
  // 删除自由布局里组件
  if (stateType === "deleteElement" && isExist(uid) && isExist(elementInLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = handleFindLayoutComponentOptions([rect.options.rows[rect.options.activeIndex]], payload.uid)
    const index = elementOptions.findIndex(element => element.elementInLayoutId === elementInLayoutId)
    elementOptions.splice(index, 1)
  }
  // 删除自由布局周围组件
  if (stateType === "deleteElement" && isExist(directionIndex)) {
    const param = {
      ...payload,
      value: false
    }
    this.$store.commit(`${this.request_prefix}/CHANGE_LAYOUT_TITLE_COMPONENT_DISPLAY_HANDLE`, param)
  }
  // 删除轮播里组件
  if (stateType === "deleteElement" && isExist(swiperContent_id) && isExist(elementInSwiperId)) {
    const rect = getAttrById(stage, payload, "swiperContent")
    const elementOptions = rect.elementOptions
    const index = elementOptions.findIndex(element => element.elementInSwiperId === elementInSwiperId)
    elementOptions.splice(index, 1)
  }
  // 删除自动布局里的组件
  if (stateType === "deleteElement" && isExist(elementInAutoLayoutId)) {
    const rect = getAttrById(stage, payload, "rect")
    const elementOptions = rect.options ? rect.options.elementOptions : rect.elementOptions
    elementOptions.splice(index, 1)
  }
}

function undoUpdate(state, historyIndex) {
  const { stateType, payload, children, before } = state
  const { rect_id, pageLayoutId, moveDirection } = payload
  const stage = this.$store.state[this.request_prefix]
  const pageLayoutList = stage.page.pageLayoutList
  const childrens = getAttrById(stage, payload, "container").children
  const page = stage.page
  // 修改布局
  if (stateType === "updatePageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    pageLayoutList.splice(index, 1, simpleDeepClone(before))
    if (children && children.length > 0) {
      children.forEach(child => {
        childrens.push(simpleDeepClone(child))
      })
    }
  }
  // 修改非布局组件
  if (stateType === "updateRect") {
    const index = childrens.findIndex(child => child.rect_id === rect_id)
    if (!state.data) {
      state.data = deepCloneAndFreeze(childrens[index])
      this.$store.commit("states/updateHistory", { index: historyIndex, state })
    }
    childrens.splice(index, 1, simpleDeepClone(before))
  }
  // 修改布局标签
  if (stateType === "updateTabRect") {
    const index = childrens.findIndex(child => child.rect_id === rect_id)
    childrens.splice(index, 1, simpleDeepClone(before.rect))
    const pageIndex = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    pageLayoutList.splice(pageIndex, 1, simpleDeepClone(before.pageLayout))
  }
  // 修改属性值
  if (stateType === "updateProperty") {
    const attr = getAttribute.call(this, payload)
    const params = simpleDeepClone(payload)
    params.option_val = simpleDeepClone(before)
    changeOption(attr, params)
  }
  // 修改页面属性值
  if (stateType === "updatePageProperty") {
    const attr = page
    const params = simpleDeepClone(payload)
    params.option_val = simpleDeepClone(before)
    changeOption(attr, params)
  }
  // 移动通栏位置
  if (stateType === "movePageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    const layout = simpleDeepClone(pageLayoutList[index])
    pageLayoutList.splice(index, 1)
    pageLayoutList.splice(moveDirection === "down" ? index - 1 : index + 1, 0, layout)
  }
}

function redoUpdate(state) {
  const { stateType, payload, data, children } = state
  const { rect_id, pageLayoutId, moveDirection } = payload
  const stage = this.$store.state[this.request_prefix]
  const pageLayoutList = stage.page.pageLayoutList
  const childrens = getAttrById(stage, payload, "container").children
  const page = stage.page
  // 修改布局
  if (stateType === "updatePageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    pageLayoutList.splice(index, 1, simpleDeepClone(data))
    if (children && children.length > 0) {
      const rects = children.map(item => item.rect_id)
      for (let i = childrens.length - 1; i >= 0; i--) {
        if (rects.includes(childrens[i].rect_id)) {
          childrens.splice(i, 1)
        }
      }
    }
  }
  // 修改非布局组件
  if (stateType === "updateRect") {
    const index = childrens.findIndex(child => child.rect_id === rect_id)
    childrens.splice(index, 1, simpleDeepClone(data))
  }
  // 修改布局标签
  if (stateType === "updateTabRect") {
    const index = childrens.findIndex(child => child.rect_id === rect_id)
    childrens.splice(index, 1, simpleDeepClone(data.rect))
    const pageIndex = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    pageLayoutList.splice(pageIndex, 1, simpleDeepClone(data.pageLayout))
  }
  // 修改属性值
  if (stateType === "updateProperty") {
    const attr = getAttribute.call(this, payload)
    const params = simpleDeepClone(payload)
    params.option_val = simpleDeepClone(data)
    changeOption(attr, params)
  }
  // 修改页面属性值
  if (stateType === "updatePageProperty") {
    const attr = page
    const params = simpleDeepClone(payload)
    params.option_val = simpleDeepClone(data)
    changeOption(attr, params)
  }
  // 移动通栏位置
  if (stateType === "movePageLayout") {
    const index = pageLayoutList.findIndex(layout => layout.id === pageLayoutId)
    const layout = simpleDeepClone(pageLayoutList[index])
    pageLayoutList.splice(index, 1)
    pageLayoutList.splice(moveDirection === "down" ? index + 1 : index - 1, 0, layout)
  }
}

function consoleLog(mode, state) {
  console.log(
    `%c changeData<mode: ${mode}, type: ${state.type}, stateType: ${state.stateType}>`,
    "background: orange;color: white"
  )
  console.log("state: ", state)
}

// 深度冻结对象，以免响应式
function deepFreeze(target) {
  if (target === null || typeof target !== "object" || Object.isFrozen(target)) {
    return
  }
  Object.freeze(target)
  for (const key in target) {
    deepFreeze(target[key])
  }
}

// 深拷贝数据并冻结
export function deepCloneAndFreeze(target, map = new WeakMap()) {
  if (typeof target === "object" && target !== null) {
    // 如果在表中已经存在该对象，则直接返回表中引用的对象，而不是重复递归，导致死循环栈溢出
    if (map.get(target)) {
      return map.get(target)
    }
    let cloneTarget = Array.isArray(target) ? [] : {}
    map.set(target, cloneTarget)
    for (const key in target) {
      cloneTarget[key] = deepCloneAndFreeze(target[key], map)
    }
    Object.freeze(cloneTarget)
    return cloneTarget
  } else {
    return target
  }
}

/**
 * 寻找配置路径
 * @param {*} data 要查找的对象，比如 { page: { test: [{ test: 12 }] } }
 * @param {*} property 要查找的属性，比如 test
 * @param {*} target 要查找的值，比如 12
 * @param {*} prefix 自动加前缀，比如 state
 * @param {*} mode 匹配方式，equal：等于，include：包含
 * @returns 返回字符串 比如 state.page.test[0].test
 */
function findPath(data, property, target, prefix, mode = "equal") {
  let finalPath = ""
  const find = (newVal, path) => {
    if (getDataType(newVal) === "Object") {
      for (let i in newVal) {
        const newPath = path ? `${path}.${i}` : `${i}`
        if (property === i && mode === "equal" && newVal[i] === target) {
          finalPath = newPath
        } else {
          find(newVal[i], newPath)
        }
      }
    }
    if (getDataType(newVal) === "Array") {
      for (let i in newVal) {
        const newPath = `${path}`
        if (mode === "equal" && newVal === target && newPath.endsWith(`.${property}`)) {
          finalPath = newPath
        } else if (
          mode === "include" &&
          Array.isArray(newVal) &&
          newVal.includes(target) &&
          newPath.endsWith(`.${property}`)
        ) {
          finalPath = newPath
        } else {
          find(newVal[i], `${newPath}[${i}]`)
        }
      }
    }
  }
  find(data, "")
  return `${prefix}${finalPath}`
}

// 获取数据类型
function getDataType(data) {
  const typeStr = Object.prototype.toString.call(data)
  return typeStr.slice(8, -1)
}

/**
 * 根据布局获取内部所有rectId
 * @param {*} cellVal
 * @param {*} rectIds
 */
function getAllRectsInCell(cellVal, rectIds) {
  cellVal.rectIds.forEach(item => {
    rectIds.push(item)
  })
  if (cellVal.layout) {
    cellVal.layout.rows.forEach(item => {
      if (item.rectIds && item.rectIds.length > 0) {
        getAllRectsInCell(item, rectIds)
      }
    })
    cellVal.layout.cols.forEach(item => {
      if (item.rectIds && item.rectIds.length > 0) {
        getAllRectsInCell(item, rectIds)
      }
    })
  }
}

/**
 * 获取修改属性的配置项
 * @returns
 */
function getAttribute(payload) {
  const {
    uid,
    directionIndex,
    elementInSwiperId,
    elementInAutoLayoutId,
    pageLayoutId,
    rect_id,
    elementInLayoutId,
    container_id,
    path,
    changingTitleElement
  } = payload
  const stage = this.$store.state[this.request_prefix]
  let attr = {}
  if (uid != null && (elementInAutoLayoutId === null || typeof elementInAutoLayoutId === "undefined")) {
    let rect = getAttrById(stage, payload, "rect").options
    let ids = {
      container_id,
      rect_id,
      elementInAutoLayoutId,
      path
    }
    if (elementInAutoLayoutId !== undefined && rect.innerElement === "cxAutoLayout") {
      // 自由布局在自动布局中
      rect = getAttrById(stage, ids, "elementInAutoLayout")
    }
    const useActiveIndex = rect.categoryMode === CATEGORY_MODE.SAME ? 0 : rect.activeIndex
    let tempRect = [rect.rows[useActiveIndex]]
    const colsItem = getColsItemByUid(tempRect, uid)
    if (elementInLayoutId !== null && elementInLayoutId !== undefined) {
      attr = colsItem?.elementOptions.find(it => it.elementInLayoutId === elementInLayoutId)
    } else {
      attr = colsItem.componentBoxOptions
    }
  } else if (directionIndex != null) {
    let options = getAttrById(stage, payload, "rect").options
    if (elementInAutoLayoutId !== undefined) {
      options = getAttrById(stage, payload, "elementInAutoLayout")
    }
    if (changingTitleElement) {
      attr = options.titleOptions[directionIndex]
    } else {
      attr = options.titleOptions[directionIndex]?.elementOptions.find(
        it => it.elementInLayoutId === elementInLayoutId
      )?.options
    }
  } else if (typeof elementInSwiperId !== "undefined" && elementInSwiperId !== null) {
    attr = getAttrById(stage, payload, "elementInSwiper")
  } else if (typeof elementInAutoLayoutId !== "undefined" && elementInAutoLayoutId !== null) {
    const rect = getAttrById(stage, payload, "elementInAutoLayout")
    const tempRect = rect?.elementOptions ? rect.elementOptions : rect
    attr = rect?.elementOptions ? tempRect.find(item => item.elementInAutoLayoutId === elementInAutoLayoutId) : tempRect
  } else {
    if (rect_id === null || rect_id === undefined) {
      if (pageLayoutId !== null && pageLayoutId !== undefined) {
        attr = getAttrById(stage, payload, "pageLayout").options
      } else {
        attr = getAttrById(stage, payload, "container").options
      }
    } else {
      attr = getAttrById(stage, payload).options
    }
  }
  return attr
}

/**
 * 通过uid获取自由布局列
 * @param {*} options
 * @param {*} uid
 * @returns
 */
function getColsItemByUid(options, uid) {
  let option
  uidTravel(options, uid)
  function uidTravel(options, uid) {
    let _rows = options
    let _outStatus = false
    if (_rows) {
      _rows.forEach(rowsItem => {
        if (rowsItem && rowsItem.cols && !_outStatus) {
          let itemCols = rowsItem.cols
          itemCols.forEach(colsItem => {
            if (colsItem.uid === uid) {
              _outStatus = true
              option = colsItem
              return
            }
            if (colsItem.uid !== uid && colsItem.rows !== null) {
              uidTravel(colsItem.rows, uid)
            }
          })
        } else {
          return
        }
      })
    }
  }
  return option
}

/**
 * 将函数进行包装，把里面的option修改项整合
 * @param {*} func
 * @returns
 */
export const historyCombineWrap = func => {
  return function () {
    const args = arguments
    sessionStorage.setItem("historyValueCombine", 1)
    try {
      func.apply(this, args)
    } catch (e) {}
    sessionStorage.removeItem("historyValueCombine")
  }
}

/**
 * 将函数进行包装，中间的提交不记录
 * @param {*} func
 * @returns
 */
export const historyIgnoreWrap = func => {
  return function () {
    const args = arguments
    sessionStorage.setItem("nextHistoryNotSave", 1)
    try {
      func.apply(this, args)
    } catch (e) {}
    sessionStorage.removeItem("nextHistoryNotSave")
  }
}

/**
 * 获取当前设置项的值
 * @param {*} attr
 * @param {*} option_name
 */
function getOptionValue(attr, option_name) {
  let oldValue
  if (Array.isArray(option_name)) {
    oldValue = option_name.map(name => {
      let old = attr
      name.split(".").forEach(item => {
        old = old[item]
      })
      return old === undefined ? DEFAULT_PROPERTY_VALUE[name] : old
    })
  } else {
    let old = attr
    option_name.split(".").forEach(item => {
      old = old[item]
    })
    oldValue = old === undefined ? DEFAULT_PROPERTY_VALUE[option_name] : old
  }
  return oldValue
}

/**
 * 把所有组件的methonds加上历史记录合并标识，修改的属性合并在一个记录里
 * @param {*} Component
 * @returns
 */
export function withMethodsHistoryCombine(Component) {
  const oldMethods = Component.methods

  Component.methods = {
    ...oldMethods,
    ...combineMethods(oldMethods)
  }

  return Component
}

/**
 * 添加历史记录合并标识
 * @param {*} methods
 * @returns
 */
function combineMethods(methods) {
  const combinedMethods = {}

  Object.keys(methods).forEach(methodName => {
    combinedMethods[methodName] = function (...args) {
      // 如果存在historyValueCombine，说明其它setter在修改，不重置值
      const otherSetterUpdate = sessionStorage.getItem("historyValueCombine")
      if (!otherSetterUpdate) {
        sessionStorage.setItem("historyValueCombine", 1)
      }
      let result
      try {
        result = methods[methodName].apply(this, args)
      } catch (e) {}
      if (!otherSetterUpdate) {
        sessionStorage.removeItem("historyValueCombine")
      }
      return result
    }
  })

  return combinedMethods
}

/**
 * 撤销后激活项
 * @param {*} type
 * @param {*} stateType
 * @param {*} ids
 */
function undoActive(type, stateType, ids) {
  if (type === "add") {
    this.$store.commit("states/changeActiveID", null)
    this.$store.commit("states/changeElementType", null)
  } else {
    activeHandle.call(this, ids)
  }
}

/**
 * 重做后激活项
 * @param {*} type
 * @param {*} stateType
 * @param {*} ids
 */
function redoActive(type, stateType, ids) {
  if (type === "delete" && stateType !== "deletePageLayoutCol") {
    this.$store.commit("states/changeActiveID", null)
    this.$store.commit("states/changeElementType", null)
  } else {
    activeHandle.call(this, ids)
  }
}

/**
 * 激活组件统一处理方法
 * @param {*} ids
 */
function activeHandle(ids) {
  const stage = this.$store.state[this.request_prefix]
  const isBigScreen = this.request_prefix === "bigScreen" || stage.page.isPhoneFullScreen || stage.page.isOnlyH5Template
  const childrens = getAttrById(stage, ids, "container").children
  const {
    rect_id,
    elementInLayoutId,
    uid,
    directionIndex,
    swiperContent_id,
    elementInSwiperId,
    elementInAutoLayoutId
  } = ids
  if (isBigScreen) {
    if (isExist(uid) || isExist(directionIndex) || isExist(elementInSwiperId)) {
      this.$store.dispatch(this.request_prefix + "/setActive", ids)
      this.$store.commit("states/changeActiveID", ids)
    } else if (isExist(rect_id)) {
      this.$store.commit("states/changeActiveID", ids)
      const rect = childrens.find(item => item.rect_id === rect_id)
      this.$store.commit("states/changeElementType", rect.shape)
    } else {
      this.$store.commit("states/changeActiveID", null)
      this.$store.commit("states/changeElementType", null)
    }
  } else {
    if (isExist(uid)) {
    } else if (isExist(directionIndex)) {
    } else if (isExist(elementInSwiperId)) {
      this.$store.dispatch(this.request_prefix + "/setActive", ids)
      this.$store.commit("states/changeActiveID", ids)
    } else if (isExist(elementInAutoLayoutId)) {
    } else if (isExist(rect_id)) {
      this.$store.dispatch(this.request_prefix + "/setActive", ids)
      this.$store.commit("states/changeActiveID", ids)
    } else {
      this.$store.commit("states/changeActiveID", null)
      this.$store.commit("states/changeElementType", null)
    }
  }
}
